import Styled from 'styled-components';
import {PopupElement} from '../../core/context-menu/context_menu.styled';

export const SelectDropdownContainer = Styled.div`
`;

export const DropdownMenu = Styled.div`
	border-radius: 6px;
	box-shadow: 0px 4px 8px 4px rgba(0, 0, 0, 0.1);;
    width: fit-content;
    padding: 10px 0;
	position: absolute;
	background: white;
	z-index: 10;
`;

export const SelectDropdownStyled = Styled.div`
    width: fit-content;
	cursor: ${({disabled}) => (disabled ? 'default' : 'pointer')};
	border-radius: 4px;
	font-size: 12px;
	line-height: 12px;
    padding: 5px 0px 5px 8px;
	display: flex;
    align-items: center;
    column-gap: 8px;
    border: 1px solid transparent;
    
    :hover, &.expanded {
	    background-color: ${({disabled}) => !disabled && '#F7F7FE'};
    }
	color: ${({disabled}) => disabled && '#a1a1a1'};
`;

export const OptionStyle = Styled(PopupElement)`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 0;
	margin: 0;
	font-size: 12px;
	padding: 4px 12px;
	cursor: ${({disabled}) => (disabled ? 'default' : 'pointer')};
	color: ${({disabled}) => (disabled ? '#a1a1a1' : '#545454')};
`;
